var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgInstagram(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 33,
    viewBox: "0 0 33 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.669 0.274536H9.33065C4.46143 0.274536 0.5 4.23616 0.5 9.10538V23.4437C0.5 28.3131 4.46143 32.2745 9.33065 32.2745H23.669C28.5386 32.2745 32.5 28.3129 32.5 23.4437V9.10538C32.5002 4.23616 28.5386 0.274536 23.669 0.274536ZM29.661 23.4437C29.661 26.7476 26.973 29.4353 23.6692 29.4353H9.33065C6.02697 29.4355 3.3392 26.7476 3.3392 23.4437V9.10538C3.3392 5.80169 6.02697 3.11373 9.33065 3.11373H23.669C26.9728 3.11373 29.6608 5.80169 29.6608 9.10538V23.4437H29.661ZM16.5 7.89358C11.8787 7.89358 8.11905 11.6533 8.11905 16.2747C8.11905 20.896 11.8787 24.6555 16.5 24.6555C21.1213 24.6555 24.881 20.896 24.881 16.2747C24.881 11.6533 21.1213 7.89358 16.5 7.89358ZM16.5 21.7694C13.4701 21.7694 11.0049 19.3045 11.0049 16.2745C11.0049 13.2444 13.4699 10.7793 16.5 10.7793C19.5301 10.7793 21.9951 13.2444 21.9951 16.2745C21.9951 19.3045 19.5299 21.7694 16.5 21.7694ZM25.6429 4.84597C25.0423 4.84597 24.4524 5.08908 24.0283 5.51506C23.6021 5.93895 23.3571 6.52908 23.3571 7.13168C23.3571 7.73241 23.6023 8.32233 24.0283 8.7483C24.4522 9.1722 25.0423 9.41739 25.6429 9.41739C26.2455 9.41739 26.8335 9.1722 27.2595 8.7483C27.6855 8.32233 27.9286 7.7322 27.9286 7.13168C27.9286 6.52908 27.6855 5.93895 27.2595 5.51506C26.8356 5.08908 26.2455 4.84597 25.6429 4.84597Z",
    fill: "white"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstagram);
export default __webpack_public_path__ + "static/media/instagram.7efa547a4414445bf8fe0d8b3892f4f5.svg";
export { ForwardRef as ReactComponent };